<template>
	<div>		
		<section class="section verQuinielaView">
			
			<div class="tile is-ancestor">
				<div class="tile is-4 is-vertical is-parent">
					<InfoQuiniela :quiniela="quiniela" />
					<Solicitudes :solicitudes="quiniela.solicitudes" v-if="loggedIn && quiniela.creador != undefined && quiniela.creador.id == user.user.id && quiniela.solicitudes != undefined" v-on:aceptar="aceptarUsuario" v-on:rechazar="rechazarUsuario" />
					<TicketParlay v-if="quiniela.tipo == 0" :quiniela="quiniela" :partidos="quiniela.partidos" :predicciones="quiniela.creador.predicciones" />
					<GanadorQuiniela v-if="quiniela.tipo == 1 && quiniela.estado == 3" :jugadores="quiniela.jugadores" />
					<JugadoresQuiniela v-if="quiniela.tipo == 1" :jugadores="quiniela.jugadores" v-on:verUsuario="verQuinielaUsuario" />
					
				</div>
				<div class="tile is-parent">
					<PartidosQuiniela style="width: 100%" :quiniela="quiniela" v-on:unirseClick="unirseQuiniela" :jugador="jugadorSeleccionado" />
				</div>
				<div class="tile is-parent is-vertical">

					<Panel :title="'Compartir'" :icon="'share-alt'" ref="compartirComp">
						<div class="panel-block buttons">
							<a class="button is-primary" :href="whatsAppLink">
								<font-awesome-icon :icon="['fab','whatsapp']"/>
							</a>
							<a class="button is-info" :href="facebookShareLink" target="_blank">
								<font-awesome-icon :icon="['fab','facebook-f']"/>
							</a>
						</div>
					</Panel>
				</div>
			</div>
		</section>
		<AyudaVisual v-if="quiniela.tipo == 1 && quiniela.estado == 0 && mostrarAyudaVisual && loggedIn && this.quiniela.jugadores.find(jugador => jugador.id === user.user.id)" texto="Comparte tu quiniela con tus amigos, mientras mas jugadores se unan a ella mayor el premio a ganar $" :comp="$refs.compartirComp" :id="$route.params.id" customNotificationClass="quiniela-top" />
		<HacerQuinielaModal :key="quiniela.id + '-' + componentKey" v-if="quiniela.tipo == 1" :partidos="quiniela.partidos" :active="modalQuiniela" v-on:close="closeModal" :info="quiniela" />
	</div>
</template>

<script>
	import InfoQuiniela from '@/components/InfoQuiniela'
	import TicketParlay from '@/components/TicketParlay'
	import JugadoresQuiniela from '@/components/JugadoresQuiniela'
	import GanadorQuiniela from '@/components/GanadorQuiniela'
	import PartidosQuiniela from '@/components/PartidosQuiniela'
	import Panel from '@/components/Panel'
	import HacerQuinielaModal from '@/components/HacerQuinielaModal'
	import { mapState, mapGetters } from 'vuex'
	import Solicitudes from '@/components/Solicitudes'
	import QuinielazoEcho from "@/services/QuinielazoEcho"
	import AyudaVisual from '@/components/AyudaVisual'

	export default {
		components: { InfoQuiniela, TicketParlay, PartidosQuiniela, JugadoresQuiniela, GanadorQuiniela, Panel, HacerQuinielaModal, Solicitudes, AyudaVisual },
		name: 'VerQuiniela',
		created(){
			this.$store.dispatch('quinielas/fetchQuiniela',{id: this.$route.params.id })
			.then(resp => {
				if (resp.response && resp.response.status == 404) {
					this.$router.push({name: 'jugar'})
				}
				this.forceRerender()
				this.mostrarAyudaVisual = true
			})
		},
		computed: {
			...mapState('quinielas',['quiniela']),
			...mapState('user',['user']),
			...mapGetters(['loggedIn']),
			facebookShareLink(){
				return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI('https://quinielazo.com/ver-quiniela/' + this.$route.params.id + '?utm_source=facebook&utm_medium=webapp&utm_campaign=ver-quiniela')
			},
			whatsAppLink(){
				return 'whatsapp://send?text=' + encodeURIComponent(window.location.origin + '/ver-quiniela/'+ this.$route.params.id +'?utm_source=whatsapp&utm_medium=webapp&utm_campaign=ver-quiniela')
			}
		},
		data() {
			return {
				modalQuiniela: false,
				componentKey: 0,
				loginModal: false,
				jugadorSeleccionado: null,
				mostrarAyudaVisual: false
			};
		},
		methods: {
			closeModal(){
				this.modalQuiniela = false
			},
			unirseQuiniela(){
				//if logged in
				if (!this.loggedIn) {
					this.$store.dispatch('login/loginOpen', {name: 'ver-quiniela',params: {id: this.quiniela.id}})
				}else{
					this.openModal()
				}
			},
			openModal(){
				this.modalQuiniela = true
			},
			forceRerender(){
				this.componentKey += 1
			},
			verQuinielaUsuario(jugador){
				this.jugadorSeleccionado = jugador
			},
			aceptarUsuario(solicitud){ 
				//Acepta usuario en quiniela privada
				this.$store.dispatch('quinielas/aceptarSolicitud',solicitud)
			},
			rechazarUsuario(solicitud){
				this.$store.dispatch('quinielas/rechazarSolicitud',solicitud)
				.then(() => {

				})
			},
			registerEchoListeners(){
				//Private channel for members of this quiniela
				QuinielazoEcho.private('quiniela.' + this.$route.params.id)
				.listen('.quiniela.usuario-agregado', message => {
					console.log(message)
					this.$store.dispatch('quinielas/update', message.quiniela)
				})
			},
			partidosText(){
				if (this.quiniela.partidos != undefined) {
					let partidos = this.quiniela.partidos.map(function(partido){
						return partido.equipo_local.nombre + ' vs ' + partido.equipo_visitante.nombre;
					})
					
					return partidos.join(', ')
				}
			}
		},
		mounted(){
			// window.scrollTo(0,0)
			if (this.loggedIn != this.quiniela.estado < 3) {
				this.registerEchoListeners()
			}
		},
		beforeDestroy(){
			QuinielazoEcho.leave('quiniela.' + this.quiniela.id)
		},
		metaInfo(){
			return{
				title: 'Quiniela - '+ (this.quiniela != undefined ? this.quiniela.nombre:'') +' - Quinielazo.com',
				meta:[
					{
						name: 'description',
						content: 'Quiniela ' + (this.quiniela != undefined ? this.quiniela.nombre:'') + ' creada por ' +(this.quiniela.creador != undefined ? this.quiniela.creador.name:'') +', con apuesta de $'+(this.quiniela != undefined ? this.quiniela.apuesta:'')+' Partidos de quiniela: ' + this.partidosText()
					},
					{
						name: 'author',
						content: (this.quiniela.creador != undefined ? this.quiniela.creador.name:'')
					},
					{
						property: 'og:title',
						content: 'Quiniela - '+ (this.quiniela != undefined ? this.quiniela.nombre:'') +' - Quinielazo.com'
					},
					{
						property: 'og:description',
						content: 'Quiniela ' + (this.quiniela != undefined ? this.quiniela.nombre:'') + ' creada por ' +(this.quiniela.creador != undefined ? this.quiniela.creador.name:'')
					},
					{
						property: 'og:image',
						content: 'https://' + window.location.hostname + '/img/icons/android-chrome-384x384.png'
					},
					{
						property: 'og:locale',
						content: 'es_MX'
					},
					{
						property: 'og:site_name',
						content: 'Quinielazo'
					},
					{
						property: 'og:url',
						content: 'https://' + window.location.hostname + '/ver-quiniela/' + this.$route.params.id
					}
				]
			}
		}
	};
</script>

<style lang="css" scoped>
.verQuinielaView{
	padding: 1rem 1rem;
}
</style>
